<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view">
          <breadcrumb></breadcrumb>
          <div
            class="intro-wrapper main-x-spacing d-flex justify-space-between py-5"
          >
            <h2>{{ title }}</h2>
            <v-btn
              :ripple="false"
              depressed
              class="gen-button white--text"
              color="#60a45f"
              @click="$router.push('/menu/')"
            >
              <v-icon>add</v-icon>
              <span>Add Menu Item</span>
            </v-btn>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="10" class="body-middle-col pt-0">
                <v-form ref="addComboForm">
                  <v-tabs
                    v-model="currentTab"
                    vertical
                    light
                    class="v-tabs-wrapper"
                  >
                    <div class="tab-separator begin"></div>
                    <v-tab href="#tab-1">Menu Details</v-tab>
                    <v-tab href="#tab-2">Combo Items</v-tab>
                    <v-tab href="#tab-3">Combo Symbols</v-tab>
                    <v-tab href="#tab-4">Combo Tags</v-tab>
                    <div class="tab-separator end"></div>

                    <v-tab-item id="tab-1" class="v-tab-item-content">
                      <div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Name:
                          </span>
                          <v-text-field
                            label="(e.g Cheese or burger meal)"
                            v-model="name"
                            hide-details
                            single-line
                            :rules="[rules.required]"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Item Status:
                          </span>
                          <v-switch
                            v-model="isAvailable"
                            hide-details
                            inset
                            class="ma-0"
                            :label="isAvailable ? 'Active' : 'Inactive'"
                          ></v-switch>
                        </div>
                        <!-- <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Default Price:
                          </span>
                          <v-text-field
                            label="0.00"
                            hide-details
                            :rules="[rules.required, rules.number]"
                            single-line
                            outlined
                            dense
                          ></v-text-field>
                        </div> -->
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Preparation
                            Time:
                          </span>
                          <v-select
                            v-model="preparationTime"
                            placeholder="Select Time"
                            :items="getTimeToMs"
                            item-value="value"
                            item-text="text"
                            :menu-props="{ offsetY: true }"
                            hide-details
                            :rules="[rules.required, rules.number]"
                            single-line
                            outlined
                            dense
                          ></v-select>
                        </div>
                        <div class="form-group d-flex align-start">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Description:
                          </span>
                          <v-textarea
                            v-model="description"
                            outlined
                            hide-details
                            name="input-7-4"
                            :rules="[rules.required]"
                          ></v-textarea>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Menu Category:
                          </span>
                          <v-select
                            v-model="getCategories"
                            flat
                            hide-details
                            outlined
                            dense
                            label="Select Category"
                            :items="categories"
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Brand
                            Availability:
                          </span>
                          <v-select
                            v-model="brandId"
                            flat
                            hide-details
                            outlined
                            dense
                            label="Select Brand"
                            :items="entepriseBrands"
                            item-text="brandName"
                            item-value="id"
                          ></v-select>
                        </div>
                        <!-- <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Cost:
                          </span>
                          <v-text-field
                            placeholder=""
                            hide-details
                            :rules="[rules.required, rules.number]"
                            single-line
                            outlined
                            dense
                          ></v-text-field>
                        </div> -->
                        <div class="form-group d-flex align-start">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Item available
                            at:
                          </span>
                          <div class="all-tags">
                            <v-select
                              v-model="locations"
                              :items="enterpriseLocations"
                              item-text="locationName"
                              item-value="id"
                              hide-details
                              chips
                              multiple
                              flat
                              solo
                            ></v-select>
                          </div>
                        </div>
                        <div class="form-group d-flex">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Image:
                          </span>

                          <div>
                            <div
                              v-if="isSelected == false"
                              class="uploadHolder uploadPreview mb-2"
                            ></div>
                            <div v-if="isSelected == true">
                              <v-img
                                contain
                                class="uploadSrc"
                                max-height="300"
                                max-width="300"
                                :src="url"
                                :rules="[rules.required]"
                              ></v-img>
                            </div>

                            <div>
                              <!-- {{ image }} -->
                              <div class="">
                                <div class="uploadButtonWrapper v-btn">
                                  <v-file-input
                                    v-model="image"
                                    @change="previewImage"
                                    @click:clear="clearSelected"
                                    color="black"
                                    hide-details
                                    placeholder="Upload File"
                                    class="text-capitalize uploadButton"
                                    flat
                                    solo
                                    prepend-icon="undefined"
                                    prepend-inner-icon="publish"
                                    :rules="[rules.required]"
                                  >
                                    <template v-slot:selection="{ text }">
                                      <v-chip small label color="primary">
                                        {{ text }}
                                      </v-chip>
                                    </template>
                                  </v-file-input>
                                  <!-- <v-btn @click="testUpload">TT</v-btn> -->
                                  <!-- isSelected is =>{{ isSelected }} -->
                                </div>

                                <!-- <span class="ml-4">No File Chosen</span> -->
                              </div>
                              <p class="caption">
                                Accepts JPG and PNG files only.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab-item>

                    <v-tab-item id="tab-2" class="v-tab-item-content">
                      <p class="text-right">
                        <v-btn
                          :ripple="false"
                          depressed
                          class="gen-button white--text"
                          color="#60a45f"
                          @click="openAddVariation"
                        >
                          <v-icon>add</v-icon>
                          <span>Add An Option</span>
                        </v-btn>
                      </p>

                      <!-- No Item Found -->
                      <v-row v-if="combos.length < 1" class="px-3">
                        <v-col cols="12" class="f9-bg">
                          <v-card class="v-card pa-12 transparent" outlined>
                            <div class="card-content">
                              <h2>No Combo option found</h2>
                              <p class="p">
                                You haven’t added any combo option yet. To
                                start, click
                                <b>Add An Option</b> to add your first combo
                                option.
                              </p>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>

                      <!-- Variation Options -->
                      <div v-else>
                        <!-- {{ combos }} -->
                        <v-form ref="comboTable">
                          <div
                            v-for="(eachCombo, index) in combos"
                            :key="index"
                            class="comboTable"
                          >
                            <div
                              class="optionHeader d-flex justify-space-between border-me-light"
                            >
                              <span class="text-uppercase">
                                {{ eachCombo.name }}
                              </span>
                              <div>
                                {{ eachCombo.price }}
                                <span class="ml-2">
                                  <v-btn
                                    :ripple="false"
                                    icon
                                    depressed
                                    text
                                    solo
                                    class="no-Btn-bg"
                                    @click="removeEachComboLayer(index)"
                                  >
                                    <v-icon color="orange">cancel</v-icon>
                                  </v-btn>
                                </span>
                              </div>
                            </div>

                            <div class="optionBody">
                              <div class="selectMenu border-me-light">
                                <v-row>
                                  <v-col cols="5">
                                    <v-select
                                      v-model="eachCombo.dataHolder.menu"
                                      placeholder="Select menu item"
                                      dense
                                      hide-details
                                      outlined
                                      append-icon="arrow_drop_down"
                                      :items="allMenu"
                                      item-text="name"
                                      return-object
                                      offset-y
                                    ></v-select>
                                  </v-col>

                                  <v-col cols="2">
                                    <v-text-field
                                      v-model="eachCombo.dataHolder.price"
                                      placeholder="Price"
                                      hide-details
                                      outlined
                                      dense
                                      :rules="[rules.required, rules.number]"
                                    >
                                    </v-text-field>
                                  </v-col>

                                  <v-col cols="2">
                                    <v-text-field
                                      v-model="eachCombo.dataHolder.cost"
                                      placeholder="Cost"
                                      hide-details
                                      outlined
                                      dense
                                      :rules="[rules.required, rules.number]"
                                    >
                                    </v-text-field>
                                  </v-col>

                                  <v-col cols="2">
                                    <v-select
                                      v-model="eachCombo.dataHolder.costType"
                                      class="text-capitalize"
                                      hide-details
                                      dense
                                      outlined
                                      append-icon="arrow_drop_down"
                                      placeholder="Select Cost Type"
                                      :items="[
                                        { name: 'Direct', value: 1 },
                                        {
                                          name: 'Inventory',
                                          value: 2,
                                          disabled: true,
                                        },
                                      ]"
                                      item-text="name"
                                      item-value="value"
                                    ></v-select>
                                  </v-col>

                                  <v-col cols="1">
                                    <v-btn
                                      :ripple="false"
                                      depressed
                                      class="white--text"
                                      color="#60a45f"
                                      @click="addRowCombo(index)"
                                    >
                                      <span>Add</span>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </div>

                              <!-- Variation Option Table -->
                              <table
                                v-if="eachCombo.options.length > 0"
                                class="tableUI"
                              >
                                <colgroup>
                                  <col span="1" style="width: 30%" />
                                  <col span="1" style="width: 20%" />
                                  <col span="1" style="width: 10%" />
                                  <col span="1" style="width: 15%" />
                                  <col span="1" style="width: 25%" />
                                </colgroup>
                                <thead>
                                  <tr>
                                    <th>Options</th>
                                    <th>Price</th>
                                    <th>Cost</th>
                                    <th>Cost Type</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(comboItem,
                                    index2) in eachCombo.options"
                                    :key="index2"
                                  >
                                    <td>
                                      <span>{{ comboItem.name }}</span>
                                    </td>
                                    <td>
                                      <span>{{ comboItem.price }}</span>
                                    </td>
                                    <td>
                                      <span>{{ comboItem.cost }}</span>
                                    </td>
                                    <td>
                                      <span>{{
                                        comboItem.costType == 1
                                          ? "Direct"
                                          : "Inventory"
                                      }}</span>
                                    </td>
                                    <td
                                      class="d-flex justify-space-around pa-2"
                                    >
                                      <v-btn
                                        :ripple="false"
                                        depressed
                                        class="btn-outlined gen-button"
                                        @click="
                                          deleteComboItemRow(index, index2)
                                        "
                                      >
                                        <v-icon>delete_forever</v-icon>
                                        <span>Delete</span>
                                      </v-btn>
                                      <v-btn
                                        :ripple="false"
                                        depressed
                                        class="btn-outlined gen-button"
                                        @click="
                                          openEditComboItem(
                                            index,
                                            index2,
                                            comboItem.price,
                                            comboItem.cost,
                                            comboItem.costType
                                          )
                                        "
                                      >
                                        <v-icon>edit</v-icon>
                                        <span>Edit</span>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </v-form>
                      </div>
                    </v-tab-item>

                    <v-tab-item id="tab-3" class="v-tab-item-content">
                      <v-alert color="#c4c4c4">
                        This is used as an attempt at allegen control. It also
                        provides a guide to trustworthy dietray Symbols such as
                        the vegan heart and crossed grains symbol. Will be
                        visible to cashiers.</v-alert
                      >
                      <p>Click on button to select</p>
                      <div class="created-tags-div">
                        <v-text-field
                          label="Type and press enter to create a tag"
                          placeholder="e.g Vegeterian"
                          v-on:keyup.enter="submitSymbols"
                          v-model="typedSymbol"
                          outlined
                          dense
                        >
                        </v-text-field>
                        <div class="created-tags-div">
                          <v-chip
                            v-for="(symbol, index) in symbols"
                            :key="index"
                            class="tag-btn"
                            close
                            @click:close="removeSymbol(index)"
                          >
                            {{ symbol.name }}
                          </v-chip>
                        </div>
                      </div>
                    </v-tab-item>

                    <v-tab-item id="tab-4" class="v-tab-item-content">
                      <v-text-field
                        label="Type and press enter to create a tag"
                        v-on:keyup.enter="submitTags"
                        v-model="typedTag"
                        outlined
                        dense
                      >
                      </v-text-field>
                      <div class="created-tags-div">
                        <v-chip
                          v-for="(tag, index) in tags"
                          :key="index"
                          class="tag-btn"
                          close
                          @click:close="removeTag(index)"
                        >
                          {{ tag.name }}
                        </v-chip>
                      </div>
                    </v-tab-item>
                  </v-tabs>
                </v-form>
              </v-col>
              <v-col cols="2" class="col-2-side-tab col-2-side-tab-right">
                <div class="side-tab-child">
                  <h4>Feeling good? Hit the button below.</h4>
                  <v-btn
                    :ripple="false"
                    depressed
                    width="100%"
                    large
                    class="success gen-button white--text mt-2"
                    :loading="addComboLoader"
                    @click="
                      currentTab == 'tab-4'
                        ? addMenu()
                        : (currentTab = 'tab-' + getNextTabNo)
                    "
                  >
                    <span v-if="currentTab !== 'tab-4'">Next</span>
                    <span v-else>Finish</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Variation -->
                <div v-if="addNewVariationActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add A New Option</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <div>Select Variation</div>
                        <v-select
                          v-model="selectedVariation"
                          flat
                          hide-details
                          outlined
                          dense
                          placeholder="Select Variation"
                          :rules="[rules.required]"
                          :items="allVariations"
                          item-text="name"
                          return-object
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addVariation"
                      >Ok</v-btn
                    >
                  </div>
                </div>

                <!-- Edit Menu Option -->
                <div v-if="editMenuOptionActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Edit Combo Menu Option</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <div>Combo Menu Price</div>
                        <v-text-field
                          v-model="currentComboItem.price"
                          hide-details
                          single-line
                          :rules="[rules.required, rules.number]"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <div>Combo Menu Cost</div>
                        <v-text-field
                          v-model="currentComboItem.cost"
                          hide-details
                          single-line
                          :rules="[rules.required, rules.number]"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <div>Combo Menu Cost Type</div>
                        <v-select
                          v-model="currentComboItem.costType"
                          class="text-capitalize"
                          hide-details
                          outlined
                          append-icon="arrow_drop_down"
                          placeholder="Select Cost Type"
                          :items="[
                            { name: 'Direct', value: 1 },
                            {
                              name: 'Inventory',
                              value: 2,
                              disabled: true,
                            },
                          ]"
                          item-text="name"
                          item-value="value"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="editComboItemOption"
                      >Ok</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      currentTab: "tab-1",
      title: "New Combo Item",
      addComboLoader: false,
      menuLoader: false,
      combos: [],
      currentComboItem: {},
      name: "",
      isAvailable: false,
      price: "",
      cost: "",
      costType: "",
      description: "",
      preparationTime: "",
      // subCategory: "",
      getCategories: "",
      brandId: "",
      locations: [],
      tags: [],
      typedTag: "",
      symbols: [],
      typedSymbol: [],
      image: [], // must be an array
      imageUrl: "",
      imageBase64: "",
      isSelected: false,
      url: "",
      editMenuOptionActive: false,
      addNewVariationActive: false,
      selectedVariation: "",
      selectedMenu: "",
      variationPrice: "",
      variationCost: "",
      variationCostType: "",
      deleteLoader: false,
      groupName: "",
      min: "",
      max: "",
      switch1: true,
      openDialog: false,
      bulkUploadMenuActive: false,
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    removeEachComboLayer(index) {
      this.combos.splice(index, 1);
    },
    calcComboItemTotal() {
      // This function calculates total of each menu combo layer
      let originCombos = this.combos;

      for (let i = 0; i < originCombos.length; i++) {
        let total = 0;
        const options = originCombos[i].options;

        options.forEach((item) => {
          total += parseInt(item.price);
        });
        originCombos[i].price = total;
      }
    },
    addRowCombo(index) {
      let currentRow = this.combos[index].dataHolder;
      if (
        !currentRow.menu ||
        !currentRow.price ||
        !currentRow.cost ||
        !currentRow.costType
      ) {
        alert("Menu, Price, Cost and Cost Type can not be empty");
      } else {
        if (parseInt(currentRow.price)) {
          this.combos[index].options.push({
            name: currentRow.menu.name,
            price: currentRow.price,
            enterpriseId: this.$store.state.enterpriseID,
            cost: currentRow.cost,
            costType: currentRow.costType,
          });

          this.combos[index].dataHolder = {}; // reset data holder
          this.$refs.comboTable.resetValidation(); // reset validation
        } else {
          alert("Invalid Price amount");
        }
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    removeSymbol(index) {
      this.symbols.splice(index, 1);
    },
    openAddVariation() {
      this.addNewVariationActive = true;
      this.openDialog = true;
    },
    addVariation() {
      // check if variation has been previously selected
      const prevSelected = () =>
        this.combos.some((combo) => this.selectedVariation.name === combo.name);

      if (prevSelected()) {
        return alert("Duplicate Variation");
      }

      if (this.$refs.dialogForm.validate()) {
        this.combos.push({
          dataHolder: {}, // temp form holder
          name: this.selectedVariation.name,
          menuName: this.name,
          globalVariationId: this.selectedVariation.id,
          enterpriseId: this.$store.state.enterpriseID,
          price: 0,
          options: [],
        });

        this.addNewVariationActive = false;
        this.openDialog = false;

        // Clear form
        this.$refs.dialogForm.reset();
      }
    },
    deleteVariationRow(index) {
      this.menuVariations.splice(index, 1);
    },
    removeItem(index) {
      if (this.newCategories.length > 1) {
        this.newCategories.splice(index, 1);
      }
    },
    addMore() {
      this.newCategories.push({ name: "" });
    },
    previewImage() {
      if (this.image) {
        this.isSelected = true;
        this.url = URL.createObjectURL(this.image);
      }
    },
    clearSelected() {
      this.isSelected = false;
      this.url = "";
    },
    testUpload() {
      this.isSelected = !this.isSelected;
      this.url = "";
    },
    async addMenu() {
      // alert("Here to serve");

      if (this.$refs.addComboForm.validate()) {
        this.addComboLoader = true;

        // Detect if file was uploaded
        if (this.image.type) {
          const file = {
            file: this.image,
            tags: "external_temp",
          };

          await this.$store
            .dispatch("uploadToCloudinary", file)
            .then((response) => {
              if (response.status == 200 || response.status == 201) {
                // set image url
                this.imageUrl = response.data.secure_url;
              } else if (response.status != 200 || response.status != 201) {
                this.menuLoader = false;
                alert("Error uploading Image");
                return process.abort();
              }
            });
        } else {
          // TEST PURPOSE ONLY
          // this.image =
          //   "https://res.cloudinary.com/whoigem4tf/image/upload/v1605697652/cnzb6xea7emyg3vc1asi.jpg";
        }

        this.combos.map((combo) => {
          delete combo.dataHolder;
        });

        let comboForm = {
          name: this.name,
          isAvailable: this.isAvailable,
          preparationTime: this.preparationTime,
          description: this.description,
          categories: [this.getCategories], // for single array submission
          brandId: this.brandId,
          locations: this.locations,
          tags: this.tags,
          symbols: this.symbols,
          image: this.imageUrl,
          isCombo: true,
          menuvariations: this.combos,
        };

        return axios
          .post("/api/v1/menu", comboForm, {
            headers: { Authorization: this.$store.state.token },
          })
          .then(() => {
            try {
              setTimeout(() => {
                this.$router.push("/combos");
                this.menuLoader = false;
                this.addComboLoader = false;
              }, 1000);
            } catch (error) {
              return error;
            }
          })
          .catch((error) => {
            this.image = "";

            this.addComboLoader = false;

            // Notification
            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error creating Combo";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      } else {
        alert("Incomplete submission. Please crosscheck");

        // reset form validation after an error
        this.$refs.comboForm.resetValidation();
      }
    },
    toBase64() {},
    uploadMenu() {
      this.bulkUploadMenuActive = true;
      this.openDialog = true;
    },
    previewImageSelected() {
      this.url = URL.createObjectURL(this.image);
    },
    deleteComboItemRow(index, index2) {
      this.combos[index].options.splice(index2, 1);
    },
    editComboItemRow(index, index2) {
      this.combos[index].options.splice(index2, 1);
    },
    openEditComboItem(index, index2, price, cost, costType) {
      this.editMenuOptionActive = true;
      this.openDialog = true;

      this.currentComboItem.index = index;
      this.currentComboItem.index2 = index2;
      this.currentComboItem.price = price;
      this.currentComboItem.cost = cost;
      this.currentComboItem.costType = costType;
    },
    editComboItemOption() {
      let index = this.currentComboItem.index;
      let index2 = this.currentComboItem.index2;

      let price = this.currentComboItem.price;
      let cost = this.currentComboItem.cost;
      let costType = this.currentComboItem.costType;

      this.combos[index].options[index2].price = price;
      this.combos[index].options[index2].cost = cost;
      this.combos[index].options[index2].costType = costType;

      this.openDialog = false;
    },
    submitTags() {
      this.tags.push({
        name: this.typedTag,
        enterpriseId: this.enterpriseID,
      });

      return (this.typedTag = "");
    },
    submitSymbols() {
      this.symbols.push({
        name: this.typedSymbol,
        enterpriseId: this.enterpriseID,
      });

      return (this.typedSymbol = "");
    },
  },
  watch: {
    openDialog(val) {
      if (val == false) {
        this.$refs.dialogForm.reset();

        this.editMenuOptionActive = false;
        this.addNewVariationActive = false;
      }
    },
  },
  created() {
    this.$store.dispatch("getAllCategories");
    this.$store.dispatch("getAllMenu");
    this.$store.dispatch("getAllvariations");
  },
  updated() {
    // Run each time there is any dom update
    this.calcComboItemTotal();
  },
  computed: {
    ...mapState([
      "mainNav",
      "allMenu",
      "categories",
      "entepriseBrands",
      "enterpriseLocations",
      "allVariations",
      "enterpriseID",
    ]),
    getNextTabNo() {
      let current = parseInt(this.currentTab.slice(-1));

      current++;

      const stageValidity = this.$refs.addMenuForm.validate();

      return stageValidity ? current : null;
    },
    getTimeToMs() {
      let allOptions = [1, 3, 5, 10, 15, 20, 30];

      for (let i = 0; i < allOptions.length; i++) {
        allOptions[i] = {
          value: allOptions[i],
          text: allOptions[i] + " " + "Minutes",
        };
        allOptions[i].value = parseInt(allOptions[i].value) * 60 * 10000; // convert to ms
      }

      return allOptions || [];
    },
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
  },
};
</script>

<style scoped>
.flex3-div,
.flex2-div {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.created-tags-div {
  margin-top: 4%;
}

.tag-btn {
  margin-right: 1%;
  margin-top: 1%;
}

.tag-name {
  text-transform: capitalize;
}

.tag-icon {
  color: black;
  font-size: 12px;
}

.all-tags {
  border: 1px solid lightgrey;
  flex: auto;
}

.form-group {
  margin-bottom: 14px;
}

.form-group .label-spacing {
  width: 18%;
  text-align: right;
}

.uploadPreview {
  width: 300px;
  height: 300px;
}

.tableUI tr:nth-child(even) {
  background-color: unset;
}

.modifier-inner-row .col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
}

.modifier-inner-row.row {
  padding-top: 0px;
}

.modifier-inner-row.innerRow2 .col {
  border-bottom: 1px solid #dddddd;
  padding-left: 12px;
  padding-right: 12px;
}

.modifier-inner-table {
  border-collapse: collapse;
  width: 100%;
}

.modifier-inner-table thead th:last-child {
  width: 40%;
}

.modifier-inner-table thead tr th {
  padding-top: 0;
  padding-bottom: 0;
}

.modifier-inner-table tr {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-p {
  font-size: 13px;
}

.removeItem {
  position: absolute;
  left: -5px;
}

/* Combo Table */
.comboTable {
  box-shadow: 0px 2px 3px -2px #b7b2b2;
  margin-bottom: 50px;
}
.comboTable thead {
  background-color: #f9f9f9;
}

.comboTable .optionHeader {
  background-color: #8b8b8b;
  color: white;
  padding: 16px;
  font-weight: bold;
}

.comboTable .optionBody .selectMenu {
  padding: 5px 25px;
  background-color: #f9f9f9;
  border-bottom: none;
}

>>> .v-slide-group__content.v-tabs-bar__content {
  height: 100vh;
}
</style>
